import React from 'react';
import { useQuery } from '@apollo/client';
import { LOADING_MESSAGE, ERROR_MESSAGE } from '../Messages/Messages';
import LoggedInLeftNav from './LoggedInLeftNav';
import LoggedOutLeftNav from './LoggedOutLeftNav';
import { ACCOUNT_PAGES_NAV_QUERY } from './operations';

/**
 * @name AccountPagesNav
 * @description Renders either the logged in or logged out left navigation based on user authentication state
 * @public
 * @returns {JSX.Element} The appropriate left navigation component based on user login status
 */
export default function AccountPagesNav() {
  const {
    data,
    error,
    loading,
  } = useQuery(
    ACCOUNT_PAGES_NAV_QUERY,
  );
  if (loading) return LOADING_MESSAGE;

  if (error) return ERROR_MESSAGE;

  const { userState: { isLoggedIn } } = data;

  return isLoggedIn ? <LoggedInLeftNav /> : <LoggedOutLeftNav />;
}
